import {IconArrowBarToDown, IconArrowBarToUp, IconWallet, IconX} from "@tabler/icons-react";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {trackDepositButtonClick} from "../../providers/analytics";
import {useAuthStore} from "../../store/useAuth.store";
import {useBalanceStore} from "../../store/useBalance.store";
import styles from "./FloatButton.module.css";

const FloatButtonWallet = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  // Listen for floating menu events
  useEffect(() => {
    const handleFloatingMenuOpen = () => {
      if (isExpanded) {
        setIsExpanded(false);
        setIsClosing(true);
        setTimeout(() => setIsClosing(false), 250);
      }
    };

    const handleMultiGameMenuOpen = () => {
      if (isExpanded) {
        setIsExpanded(false);
        setIsClosing(true);
        setTimeout(() => setIsClosing(false), 250);
      }
    };

    window.addEventListener("floating-menu-opened", handleFloatingMenuOpen);
    window.addEventListener("multi-game-menu-opened", handleMultiGameMenuOpen);

    return () => {
      window.removeEventListener("floating-menu-opened", handleFloatingMenuOpen);
      window.removeEventListener("multi-game-menu-opened", handleMultiGameMenuOpen);
    };
  }, [isExpanded]);
  const authStatus = useAuthStore(state => state.authStatus);
  const handleBankAccountModal = useBalanceStore(state => state.handleBankAccountModal);
  const handleWithdrawalModal = useBalanceStore(state => state.handleWithdrawalModal);

  const {t} = useTranslation();

  const toggleWalletMenu = () => {
    if (isExpanded) {
      setIsExpanded(false);
      setIsClosing(true);
      setTimeout(() => setIsClosing(false), 250);
    } else {
      window.dispatchEvent(new CustomEvent("wallet-menu-opened"));
      setIsExpanded(true);
      setIsClosing(false);
    }
    trackDepositButtonClick();
  };

  const handleDeposit = () => {
    handleBankAccountModal();
    setIsExpanded(false);
    setIsClosing(true);
    setTimeout(() => setIsClosing(false), 250);
  };

  const handleWithdrawal = () => {
    handleWithdrawalModal();
    setIsExpanded(false);
    setIsClosing(true);
    setTimeout(() => setIsClosing(false), 250);
  };

  return (
    <>
      {authStatus === "authenticated" && (
        <div
          id="float-wallet-btn"
          className={styles.walletContainer}
        >
          {(isExpanded || isClosing) && (
            <div className={`${styles.walletMenu} ${isClosing ? styles.collapsing : ""}`}>
              <button
                type="button"
                className={`${styles.walletIconOption} ${styles.actionButton}`}
                onClick={handleDeposit}
                aria-label={t("floatBtnDeposit")}
              >
                <IconArrowBarToDown
                  size={20}
                  stroke={2}
                  className={styles.actionIcon}
                />
                <span className={styles.iconLabel}>{t("floatBtnDeposit")}</span>
              </button>
              <button
                type="button"
                className={`${styles.walletIconOption} ${styles.actionButton}`}
                onClick={handleWithdrawal}
                aria-label={t("floatBtnWithdrawl")}
              >
                <IconArrowBarToUp
                  size={20}
                  stroke={2}
                  className={styles.actionIcon}
                />
                <span className={styles.iconLabel}>{t("floatBtnWithdrawl")}</span>
              </button>
            </div>
          )}
          <button
            type="button"
            className={`${styles.walletButton} ${isExpanded ? styles.walletButtonActive : ""}`}
            onClick={toggleWalletMenu}
            aria-label={isExpanded ? t("floatBtnClose", "Close wallet menu") : t("floatBtnWallet", "Wallet")}
            aria-expanded={isExpanded}
          >
            {isExpanded ? (
              <IconX
                key="icon-close"
                size={24}
                stroke={2}
                className={styles.iconSwap}
              />
            ) : (
              <IconWallet
                key="icon-wallet"
                size={26}
                stroke={2}
                className={styles.iconSwap}
              />
            )}
          </button>
        </div>
      )}
    </>
  );
};

export default FloatButtonWallet;
